import { useTranslation } from 'react-i18next';
import { ConstructionIcon } from '../svg/ConstructionIcon';
import '../500/styles.scss';

export const Maintenance = () => {
	const { t } = useTranslation('Common');

	return (
		<div className="error-view">
			<h1 className="title">{t('Maintenance')}</h1>
			<div className="message">
				{t('We are under maintenance. Please try again later.')}
			</div>
			<div className="image">
				<ConstructionIcon />
			</div>
		</div>
	);
};
